import elementResizeDetectorMaker from 'element-resize-detector';
import { RefObject, useEffect } from 'react';

import { useStableCallback } from './useStableCallback';

const supported = typeof window !== 'undefined' && 'ResizeObserver' in window;

/**
 * Использует нативный ResizeObserver или полифил element-resize-detector
 *
 * использовать dynamic import для element-resize-detector
 */
export const useResizeObserver = (observeRef: RefObject<HTMLElement>, onResize: () => unknown) => {
    const stableOnResize = useStableCallback(onResize);

    useEffect(() => {
        if (!observeRef.current) {
            return undefined;
        }

        const element = observeRef.current;

        if (supported) {
            // @ts-ignore ResizeObserver
            const resizeObserver = new window.ResizeObserver(stableOnResize);
            resizeObserver.observe(element);

            return () => resizeObserver.unobserve(element);
        }

        const erd = elementResizeDetectorMaker({ strategy: 'scroll' });
        erd.listenTo(element, stableOnResize);

        return () => erd.uninstall(element);
    }, [observeRef, stableOnResize]);
};
